import '../App.css'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import CalendarData from '../components/Calendar.json'
import EventCalendarRow from '../components/EventCalendarRow'
import navImg from '../assets/PCWI_Logo.svg'
import rsvp from '../assets/Website RSVP Redirect.png'
import rsvpPdf from '../assets/Website RSVP Redirect.pdf'
import EventDetails from '../components/EventDetails'
import Spinner from '../components/Spinner'


export default function Home() {
    const [cardComp, setCardComp] = useState(<></>);
    const [eventData, setEventData] = useState()
    const [loading, setLoading] = useState(true);

    const formatDate = function (d) {
        var date = new Date(d);
        var res = '';
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1);
        var yyyy = date.getFullYear();
        var HH = date.getHours();
        var MM = String(date.getMinutes());
        var AMPM = HH >= 12 ? 'pm' : 'am';
        HH = HH % 12;
        HH = HH ? HH : 12;
        MM = MM < 10 ? '0' + MM : MM;
        res = mm + '/' + dd + '/' + yyyy + ' ' + HH + ":" + MM + AMPM;
        return res
    }

    const initData = function () {
        var afterToday = [];
        for (let i = 0; i < CalendarData.length; i++) {
            if (new Date(CalendarData[i].end) >= Date.now() || CalendarData[i].start == "TBD") {
                afterToday.push(CalendarData[i])
            }
        }

        var temp = [];
        temp = afterToday.sort((a, b) => {
            return new Date(a.start) - new Date(b.start)
        })

        var comp = [];
        for (let c = 0; c < temp.length; c++) {
            comp.push(<EventCalendarRow data={temp[c]} key={temp[c].id} />)
        }

        setCardComp(comp)

        if (comp.length < 1) {
            setCardComp(<i>No upcoming events currently</i>)
        }

        let calendarTest = CalendarData
        setLoading(false)
    }

    useEffect(() => {
        initData();
    }, []);

    return (
        <div>
            <main className='flex-shrink-0 modular min-vh-100'>
                <div className='container py-4'>
                    <div className='row pb-4'>

                        <div className='card mb-3 px-0 d-none' style={{ backgroundColor: '#FAAB53', textAlign: 'center' }}>
                            <h1 className='text-light'>
                                Parker County Water Plan
                            </h1>
                        </div>

                        <div className='card px-0'>
                            <div className='card-header' >
                                <h3 className='text-light'>
                                    Welcome
                                </h3>
                            </div>
                            <div className='card-body'>
                                Planning for sustainable water supply solutions is vital in the face of the significant growth occurring in Parker County, which led to the formation of the Parker County Hydrology 2050 Committee. The Committee has commenced the Parker County Water Plan (PCWP) study to address short-term and long-term water needs for Parker County. The PCWP has initially studied the viability of groundwater continuing to meet current demands, as well as additional future demands. The PCWP recommends that interested public water systems come together to form a public utility agency (PUA) to leverage the many benefits of regional collaboration.
                            </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className='card px-0'>
                            <div className='card-header' >
                                <h3 className='text-light'>
                                    Ongoing and Upcoming Events
                                </h3>
                            </div>
                            <div className='card-body'>
                                {cardComp}
                            </div>
                        </div>

                    </div>
                </div>
            </main>
        </div>
    )
}